/**
 * Обрезанный текст ячейки — источник подсказки при наведении.
 *
 * Всё считается по факту раскладки, а не по данным: режим переноса, ширина
 * колонки и содержимое ячейки задаются в разных местах, и единственный честный
 * признак «текст не поместился» — расхождение прокрутки и видимого размера.
 */

/** Ячейка сама уже даёт подсказку: карточка пользователя, тултип из шаблона потребителя. */
const OWN_HOVER = '.user-name--interactive, .rf-tooltip, [title], [data-tip-skip]';

/** Служебные ячейки без текста. */
const SERVICE_CELL = 'dtb__cell--check dtb__cell--draggrip dtb__cell--editing dtb__tree-loading-cell'.split(' ');

/** Сколько узлов ячейки осматриваем: текст лежит у самой ячейки или неглубоко внутри. */
const MAX_NODES = 24;

const CLIPPING = /hidden|clip|auto|scroll/;

/** Содержимое обрезано только там, где есть клип: в режиме переноса ячейка ничего не прячет. */
function isClipped(el: HTMLElement): boolean {
    const style = getComputedStyle(el);
    return CLIPPING.test(style.overflowX) || CLIPPING.test(style.overflowY);
}

function isOverflowing(el: HTMLElement): boolean {
    return el.scrollWidth - el.clientWidth > 1 || el.scrollHeight - el.clientHeight > 1;
}

/**
 * Текст подсказки для ячейки или пустая строка, если подсказка не нужна:
 * содержимое помещается, ячейка служебная, редактируется или несёт собственный
 * ховер (ФИО с карточкой контактов, шаблон с тултипом).
 */
export function overflowTextOf(cell: HTMLElement): string {
    if (SERVICE_CELL.some((cls) => cell.classList.contains(cls))) return '';
    if (cell.querySelector('input, textarea, select, .dtb__row-actions')) return '';
    if (cell.matches(OWN_HOVER) || cell.querySelector(OWN_HOVER)) return '';

    const nodes: HTMLElement[] = [cell];
    for (const node of cell.querySelectorAll<HTMLElement>('*')) {
        if (nodes.length >= MAX_NODES) break;
        nodes.push(node);
    }
    const clipped = nodes.find((node) => isOverflowing(node) && isClipped(node));
    if (!clipped) return '';

    return (clipped.textContent ?? '').trim();
}
